import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { TamaguiProvider, Theme } from 'tamagui';

import AboutPage from './pages/AboutPage';
import IntegrationsPage from './pages/IntegrationsPage';
import GettingStartedPage from './pages/GettingStartedPage';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import PrivacyPage from './pages/PrivacyPage';
import SecurityPage from './pages/SecurityPage';
import TermsPage from './pages/TermsPage';
import TorchVsGlean from './pages/compare/TorchVsGlean';
import TorchVsNotion from './pages/compare/TorchVsNotion';
import UseCasesIndex from './pages/use-cases/UseCasesIndex';
import UseCasePage from './pages/use-cases/UseCasePage';
import { ThemeProvider, useTheme } from './components/ThemeController';
// import { ThemeSelector } from './components/ThemeSelector';
import { config } from './tamagui.config';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

function ThemedApp() {
  const { tamaguiTheme } = useTheme();

  return (
    <TamaguiProvider config={config} defaultTheme="dark">
      <Theme name={tamaguiTheme as any}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/features" element={<LandingPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/getting-started" element={<GettingStartedPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/compare/torch-vs-notion" element={<TorchVsNotion />} />
          <Route path="/compare/torch-vs-glean" element={<TorchVsGlean />} />
          <Route path="/use-cases" element={<UseCasesIndex />} />
          <Route path="/use-cases/:slug" element={<UseCasePage />} />
        </Routes>
        {/* <ThemeSelector /> */}
      </Theme>
    </TamaguiProvider>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  );
}
